import { findActionLinkPage } from '@shared/actionLinks/pages.js'

// Takes an action link's alias out of the URL fragment before the router and the trackers start,
// so it never reaches analytics, logs or the signup URL kept in browser storage. main.js imports
// this module first. The alias stays in memory only.
let alias = null

if (findActionLinkPage(window.location.pathname)) {
  if (window.location.hash.length > 1) {
    alias = window.location.hash.slice(1)
    window.history.replaceState(
      window.history.state,
      '',
      window.location.pathname + window.location.search,
    )
  }

  // A link opened in a tab that already shows the page only changes the fragment, without a new
  // document load. A reload runs the capture above again, so the new alias leaves the address bar
  // and the page starts over with it, instead of keeping the old state.
  window.addEventListener('hashchange', () => window.location.reload())
}

// Returns the alias once, so it doesn't outlive the view that uses it.
export const takeAlias = () => {
  const taken = alias
  alias = null
  return taken
}
